export default __webpack_public_path__ + "static/media/img_11.c0513f20.jpg";